//
import ProviderRoutes from "./PchProvider"
import ProviderAccountBankRoutes from "./PchProviderAccountBank"
import ProviderPaymentRoutes from "./PchProviderPayment"
import ProviderPaymentSheetRoutes from "./PchProviderPaymentSheet"
import PurchaseCreditNoteRoutes from "./PchPurchaseCreditNote"
import PchPurchaseDebitNoteRoutes from './PchPurchaseDebitNoteRoutes'
import PurchaseInvoiceRoutes from "./PchPurchaseInvoice"
import PurchaseOrderRoutes from "./PchPurchaseOrder"
import TaxDocumentRoutes from "./PchTaxDocument"

//
import { PurchaseInvoicePaidRoutes, RegistryInvoiceRoutes } from "./PchPurchaseInvoice"
import { ContPurchaseDocument } from "./PchTaxDocument"
import { PurchaseOrderPendingRoutes } from "./PchPurchaseOrder"

//
export default [

    //
    ContPurchaseDocument,
    PurchaseCreditNoteRoutes,
    PchPurchaseDebitNoteRoutes,
    PurchaseInvoicePaidRoutes,
    PurchaseOrderPendingRoutes,
    RegistryInvoiceRoutes,

    //
    ProviderRoutes,
    ProviderAccountBankRoutes,
    ProviderPaymentRoutes,
    ProviderPaymentSheetRoutes,
    PurchaseInvoiceRoutes,
    PurchaseOrderRoutes,
    TaxDocumentRoutes,
]